import { Collapse, Tag } from 'antd';
import styled from 'styled-components';

import { Switch } from 'components/UI';

const { Panel } = Collapse;

export const StyledPanel = styled(Panel)`
  margin-bottom: 10px;
  padding-bottom: 0;
  font-size: 12px;

  .ant-collapse-content-box {
    padding-top: 5px !important;
    padding-bottom: 0 !important;
  }

  .ant-collapse-header {
    /* Full width, so the button can be pushed to the right of the bar. */
    display: flex !important;
    align-items: center;
    width: 100%;
    padding: 0 !important;
  }

  .ant-collapse-header-text {
    /* This element carries the header content, not the header itself: without stretching it,
       the button has nothing to push against on the right. */
    display: flex;
    flex: 1;
    align-items: center;
    font-weight: bold;
    color: ${(p) => p.theme.white};
  }

  .ant-collapse-expand-icon {
    color: ${(p) => p.theme.white};
  }
`;

export const StyledTag = styled(Tag)`
  font-weight: normal;
  background: ${(p) => p.theme.primary_yellow};
  border: none;
  margin-left: 10px;
  font-size: 10px;
`;

export const StyledSwitch = styled(Switch)`
  .ant-switch-inner {
    font-size: 10px;
  }

  margin: -2px 0 0 10px;
`;

/**
 * Panel header button. Understated on purpose: it lives in a title, and the off state is the
 * normal one until a calculation has produced a grid.
 */
export const AutoGridButton = styled.button<{ $active?: boolean }>`
  /* Pushed to the far right of the bar, away from the title and its badge. */
  margin-left: auto;
  padding: 1px 10px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;

  /* Yellow when the automatic grid is in use, white when it is not: the button state is the
     only confirmation of the click, so it must read without hesitation. */
  color: ${(p) => p.theme.dark_gray};
  background: ${(p) => (p.$active ? p.theme.primary_yellow : p.theme.white)};
  border: 1px solid ${(p) => (p.$active ? p.theme.primary_yellow : p.theme.light_soft_gray)};

  &:disabled {
    background: transparent;
    border-color: ${(p) => p.theme.light_gray};
    color: ${(p) => p.theme.light_gray};
    cursor: not-allowed;
  }

  .anticon {
    margin-right: 4px;
  }
`;
